import script from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"

import "./RequestsList.vue?vue&type=style&index=0&id=6799f746&lang=css"

const __exports__ = script;

export default __exports__